module.exports = __webpack_public_path__ + "img/28.e7824904.png";